import {Injectable} from '@angular/core';
import {getSessionStorage, isStorageSupported} from '../../../pollyfills/storagePolyfill';
import {LocalStorageService} from 'app/core/services/local-storage.service';

declare let window: Window;

@Injectable()
export class SessionStorageService extends LocalStorageService {
    protected setStorage() {
        this.localStorage = getSessionStorage(window);
        console.debug(`[LocalStorageService] polyfill ${isStorageSupported() ? 'disabled' : 'enabled'}`);
    }
}
